type Window = {
    env: {
        APP_SERVICE_URL: string;
        APP_HEARTBEAT_INTERVAL: number;
        APP_VERSION?: string;
        APP_SYSTEM_LOCK_TIMEOUT?: number;
        APP_INFO_MESSAGE_MAX_CHARACTERS: number;
    };
};

const { env } = window as unknown as Window;

export { env };
